import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.weak-set";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/inputcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import ChangeBuffer from './utils/changebuffer';
/**
 * The input command. Used by the {@link module:typing/input~Input input feature} to handle typing.
 *
 * @extends module:core/command~Command
 */

var InputCommand = /*#__PURE__*/function (_Command) {
  _inherits(InputCommand, _Command);

  var _super = _createSuper(InputCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor
   * @param {Number} undoStepSize The maximum number of atomic changes
   * which can be contained in one batch in the command buffer.
   */
  function InputCommand(editor, undoStepSize) {
    var _this;

    _classCallCheck(this, InputCommand);

    _this = _super.call(this, editor);
    /**
     * Typing's change buffer used to group subsequent changes into batches.
     *
     * @readonly
     * @private
     * @member {module:typing/utils/changebuffer~ChangeBuffer} #_buffer
     */

    _this._buffer = new ChangeBuffer(editor.model, undoStepSize);
    /**
     * Stores batches created by the input command. The batches are used to differentiate input batches from other batches using
     * {@link module:typing/input~Input#isInput} method.
     *
     * @type {WeakSet<module:engine/model/batch~Batch>}
     * @protected
     */

    _this._batches = new WeakSet();
    return _this;
  }
  /**
   * The current change buffer.
   *
   * @type {module:typing/utils/changebuffer~ChangeBuffer}
   */


  _createClass(InputCommand, [{
    key: "destroy",

    /**
     * @inheritDoc
     */
    value: function destroy() {
      _get(_getPrototypeOf(InputCommand.prototype), "destroy", this).call(this);

      this._buffer.destroy();
    }
    /**
     * Executes the input command. It replaces the content within the given range with the given text.
     * Replacing is a two step process, first the content within the range is removed and then the new text is inserted
     * at the beginning of the range (which after the removal is a collapsed range).
     *
     * @fires execute
     * @param {Object} [options] The command options.
     * @param {String} [options.text=''] The text to be inserted.
     * @param {module:engine/model/range~Range} [options.range] The range in which the text is inserted. Defaults
     * to the first range in the current selection.
     * @param {module:engine/model/range~Range} [options.resultRange] The range where the selection
     * should be placed after the insertion. If not specified, the selection will be placed right after
     * the inserted text.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var doc = model.document;
      var text = options.text || '';
      var textInsertions = text.length;
      var selection = options.range ? model.createSelection(options.range) : doc.selection;
      var resultRange = options.resultRange;
      model.enqueueChange(this._buffer.batch, function (writer) {
        _this2._buffer.lock();

        model.deleteContent(selection);

        if (text) {
          model.insertContent(writer.createText(text, doc.selection.getAttributes()), selection);
        }

        if (resultRange) {
          writer.setSelection(resultRange);
        } else if (!selection.is('documentSelection')) {
          writer.setSelection(selection);
        }

        _this2._buffer.unlock();

        _this2._buffer.input(textInsertions); // Store the batch as an 'input' batch for the Input.isInput( batch ) check.


        _this2._batches.add(_this2._buffer.batch);
      });
    }
  }, {
    key: "buffer",
    get: function get() {
      return this._buffer;
    }
  }]);

  return InputCommand;
}(Command);

export { InputCommand as default };